<mat-icon [matTooltip]="tooltip()" class="step-icon {{ interactionType() }}">
  {{ icon() }}
</mat-icon>
